import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    align-items: flex-start;
    width: 100%;
    padding-left: 32px;
    position: relative;
    margin-bottom: 12px;

    @media (max-width: 990px) {
        padding-left: 0;
        margin-bottom: 12px;
        flex-direction: column;
        gap: 8px;
    }

    .data-texto {
        color: ${({ theme }) => theme.colors.interfaceText400};
        font-size: 12px;
        line-height: 1.3;
        text-align: right;
        font-weight: 500;
    }

    .hora-texto {
        color: ${({ theme }) => theme.colors.interfaceText600};
        font-weight: 600;
        font-size: 14px;
        line-height: 1.3;
        text-align: right;
    }

    .items {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        width: 100%;

        @media (max-width: 990px) {
            flex-direction: column;
            gap: 0;
        }

        .data {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            justify-content: flex-start;
            position: relative;
            cursor: help;
            gap: 2px;
            min-width: 85px;
            flex-shrink: 0;

            @media (max-width: 990px) {
                flex-direction: row;
                align-items: center;
                gap: 8px;
                min-width: 0;
                width: 100%;
                padding: 0 4px;
                margin-bottom: 8px;
                
                .data-texto {
                    text-align: left;
                    font-size: 11px;
                }
                
                .hora-texto {
                    text-align: left;
                    font-size: 12px;
                }
                
                &::after {
                    content: '·';
                    color: ${({ theme }) => theme.colors.interfaceText300};
                    font-size: 12px;
                    order: 1;
                }
                
                .data-texto {
                    order: 0;
                }
                
                .hora-texto {
                    order: 2;
                }
            }
        }

        .icone {
            height: 36px;
            width: 36px;
            min-width: 36px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 2px solid ${(props: any) => props.theme.colors.ce5e7eb};
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
            background-color: ${(props: any) => props.theme.colors.interfacePure0};
            position: relative;
            z-index: 10;
            flex-shrink: 0;

            @media (max-width: 990px) {
                display: none;
            }

            svg {
                flex-shrink: 0;
                width: 16px;
                height: 16px;
            }
        }
    }
`;

export const VLine = styled.div<{ lastItem: boolean }>`
    width: 2px;
    background-color: ${(props: any) => props.theme.colors.ce5e7eb};
    position: absolute;
    left: calc(32px + 85px + 12px + 18px);
    top: 0;
    bottom: ${({ lastItem }) => lastItem ? 'calc(99%)' : '-12px'};
    z-index: 0;

    @media (max-width: 990px) {
        display: none;
    }
`;

export const Tooltip = styled.div`
    position: fixed;
    transform: translate(-50%, calc(-100% - 8px));
    background: ${({ theme }) => theme.colors.interfaceGray700};
    color: ${({ theme }) => theme.colors.interfacePure0};
    font-size: 12px;
    font-weight: 600;
    padding: 6px 10px;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
    z-index: 99999;
    pointer-events: none;
    white-space: nowrap;

    @media (min-width: 991px) {
        transform: translate(-35%, calc(-100% - 8px));
    }

    &::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        border-width: 5px;
        border-style: solid;
        border-color: ${({ theme }) => theme.colors.interfaceGray700} transparent transparent transparent;
    }

    p {
        margin: 0;
        padding: 0;
        font-size: 11px;
        line-height: 1.4;
        color: ${({ theme }) => theme.colors.interfacePure0};
        
        strong {
            font-weight: 700;
            color: ${({ theme }) => theme.colors.interfacePure0};
        }
    }
`;
